const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/insights/sir/debug/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
interface SirDebugTabBeforeLoadArgs {
  context: {
    flags: Partial<FlagKeys>;
  };
  params: {
    org: string;
    loopId: number;
  };
}
export const sirDebugTabBeforeLoad = async ({
  context: {
    flags
  },
  params: {
    org,
    loopId
  }
}: SirDebugTabBeforeLoadArgs) => {
  if (!flags.sirDebugViewEnabled) {
    throw redirect({
      to: '/org/$org/loop/$loopId/insights',
      params: {
        org,
        loopId
      },
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/insights/sir/debug/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: sirDebugTabBeforeLoad
});